exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-alert[data-v-24bf5802]{padding:1rem;background-color:#fff4e5;border:1px solid #ddc5a4;border-radius:15px;font-weight:600;font-size:14px;color:#663c00;margin-top:10px;display:grid;grid-template-columns:15% 1fr;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.error-alert span[data-v-24bf5802]{position:relative!important;top:auto!important;color:#ffa12e!important;left:auto!important;text-align:center}.fade-enter-active[data-v-24bf5802],.fade-leave-active[data-v-24bf5802]{-webkit-transition:opacity .2s;transition:opacity .2s}.fade-enter[data-v-24bf5802],.fade-leave-to[data-v-24bf5802]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24bf5802","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/TeachersForm/components/WarningAlert.vue
// module id = 335
// module chunks = 0